const bottomBar = document.querySelector('.bottom-bar');
const tabsDiv = document.querySelector('.tabs-nav');
const quantityInputs = document.querySelectorAll(`[name="quantity"]`);
const singleProductHeader = document.querySelector('.single-product-header');

if (bottomBar && tabsDiv) {
    const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
            const section = entry.target;

            if (!entry.isIntersecting && entry.intersectionRect.y < 10) {
                bottomBar.classList.add('active');
            } else {
                bottomBar.classList.remove('active');
            }
        });
    };

    const options = {
        threshold: 0.3,
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    observer.observe(singleProductHeader);

    const addToCartButton = bottomBar.querySelector(
        '.js-bottom-bar-add-to-cart'
    );

    if (addToCartButton) {
        addToCartButton.addEventListener('click', () => {
            const variationAddToCart = document.querySelector(
                '.js-variation-add-to-cart'
            );
            const singleAddToCart = document.querySelector(
                '.js-single-add-to-cart'
            );

            if (variationAddToCart) {
                variationAddToCart.click();
            }

            if (singleAddToCart) {
                singleAddToCart.click();
            }
        });
    }
}

if (quantityInputs) {
    const handleQuantityChange = e => {
        const currentElement = e.currentTarget;
        const val = currentElement.value;
        if (val) {
            quantityInputs.forEach(input => {
                input.value = val;
            });
        }
    };

    quantityInputs.forEach(input => {
        input.addEventListener('change', handleQuantityChange);
    });
}
